export default class FormaPagamento {
    id: number | null;
    ativa: boolean;
    codigoInterno: string;
    descricao: string;
    abreviatura: string | null;
    tipoPagamentoNfe: string;

    constructor(
        id: number | null = null,
        ativa = true,
        codigoInterno = '',
        descricao = '',
        abreviatura: string | null = null,
        tipoPagamentoNfe = ''
    ) {
        this.id = id;
        this.ativa = ativa;
        this.codigoInterno = codigoInterno;
        this.descricao = descricao;
        this.abreviatura = abreviatura;
        this.tipoPagamentoNfe = tipoPagamentoNfe;
    }
}
